import type { CognitoUser } from "amazon-cognito-identity-js";

export const SignOutResolver = async (
	cognitoUser: CognitoUser,
): Promise<void> => {
	return new Promise<void>((resolve) => {
		cognitoUser.signOut(() => resolve());
	});
};
